import { Component, OnInit } from '@angular/core';
import { UmsService } from '../ums.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reports-dashboard',
  templateUrl: './reports-dashboard.component.html',
  styleUrls: ['./reports-dashboard.component.scss']
})
export class ReportsDashboardComponent implements OnInit {
  reportsList: any;

  constructor(public umsService: UmsService,
    private route: ActivatedRoute,
    public router: Router,) { }
  selectedReport = "lkndsflvsoimsoidc"
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      window.scroll(0, 0)
      let payload = {};
      payload['rptHead'] = params['MenuCode'];
      this.umsService.getReportsMenu(payload).subscribe(res => {
        this.reportsList = res.data;
        this.selectedReport = params['MenuCode']
      });
    })
  }
  redirect(to): void {
    // this.router.navigate([to]);;
    this.router.navigate([to.path], { queryParams: { MenuCode: to.code } });
  }
}
